<template>
  <div id="publication-dashboard--issues">
    <h3 is="sui-header">
      <i class="list icon"></i>
      {{ $t('Open Issues') }}
    </h3>
    <sui-divider />
    <div class="ui issues-container">
      <div class="issue" v-for="item in issuesData" :key="item.id">
        <div class="row">
          <span class="issue-item issue-basic-info"><strong>{{ $t('Title') }}:</strong> {{ item.title }}</span>
          <span class="issue-item issue-id"><strong>{{ $t('ID') }}:</strong> {{ item.iid }}</span>
        </div>
        <div class="row">
          <span class="issue-item issue-created-at"><strong>{{ $t('Created') }}:</strong> {{ item.created_at }}</span>
          <span class="issue-item issue-updated-at"><strong>{{ $t('Updated') }}:</strong> {{ item.updated_at }}</span>
          <span class="issue-item issue-due-on" v-if="item.due_date">
            <strong>{{ $t('Due') }}:</strong> {{ item.due_date }}
          </span>
        </div>
        <div class="row">
          <span class="issue-item issue-author">
            <strong>{{ $t('Opened by') }}:</strong> {{ item.author.name }}
          </span>
          <span class="issue-item issue-assignees">
            <strong>{{ $t('Assigned to') }}:</strong>
            <span v-for="(assignee, index) in item.assignees" :key="index">
              {{ assignee.name }}
            </span>
          </span>
        </div>
        <div class="labels">
          <span class="ui basic label" v-for="(label, index) in item.labels" :key="index" >{{ label }}</span>
        </div>
      </div>
      <sui-dimmer :active="loading" inverted>
        <sui-loader />
      </sui-dimmer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'issues',
  props: ['dataRequested', 'issuesData'],
  data() {
    return {
      loading: true
    };
  },
  updated() {
    this.removeLoader();
  },
  mounted() {
    this.removeLoader();
  },
  methods: {
    removeLoader() {
      if (this.dataRequested) {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#publication-dashboard--issues {
  .issues-container {
    margin: 0;
    .issue {
      .row:after {
        content: "";
        display: table;
        clear: both;
      }
      &:last-of-type {
        border-bottom: none;
        margin-bottom: 0;
      }
      padding: 0 0 1rem;
      margin: 0 0 1rem;
      border-bottom: 1px solid #e6e6e6;
      .label {
        color: #fff;
        background-color: #de348b;
        margin-bottom: 0.5rem;
      }
      .issue-item {
        display: block;
        width: 50%;
        float: left;
      }
      .labels {
        margin-top: 0.25rem;
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  span.issue-item {
    display: block;
    width: initial;
    float: none;
  }
}
</style>
